import React from "react";
import { Link } from "react-router-dom";

export default function Login() {
	return (
		<div className="login">
			<form className="form">
				<p className="form-title">Log in</p>
				<div className="form-field">
					<label htmlFor="user-email" className="field-label">
						Email
					</label>
					<input
						type="email"
						name="user-email"
						id="user-email"
						className="field-input"
						placeholder="you@example.com"
					/>
				</div>
				<div className="form-field">
					<label htmlFor="user-password" className="field-label">
						Password
					</label>
					<input
						type="email"
						name="user-password"
						id="user-password"
						className="field-input"
						placeholder="**********"
					/>
				</div>
				<button className="form-submit-button">Log in</button>
			</form>
      <Link to="/signup" className="link">don't have an account?</Link>
		</div>
	);
}
